module.exports = __webpack_public_path__ + "static/WFM_pin_hover-4779344eed3c85a4498e1b0fc0c22f7e.png";